export default "__VITE_ASSET__Co5GuDKB__"